import React from "react"
import { IconButton } from "@cd2/components"
import { icons } from "../../constants/icons"
import { QuickToolTip } from "../QuickTooltip"
import { brandColors, themeColors } from "../EOSThemeProvider"

interface IProps {
  onRemove: () => void
}

export function RemoveRowButton({ onRemove }: IProps) {
  return (
    <div>
      <QuickToolTip content={"Remove product"}>
        <IconButton
          icon={icons.cross}
          iconSize={14}
          buttonColor={brandColors.blaze}
          onClick={onRemove}
          square
        />
      </QuickToolTip>
    </div>
  )
}
